/**
 * 预览相关的功能
 * 目前为止只处理预览通用的部分
 * 1.全屏滚动条消失的逻辑
 * 2. esc退出全屏
 */
export const PREVIEW = {
  data() {
    return {
      footTimer: null, // 全屏模式下底栏记时器
      isFullScreen: false,
    }
  },
  watch: {
    /**
         * 全屏时处理底部栏和右侧栏
         */
    isFullScreen(n, o) {
      if (n) {
        this.displayRightPanel = false
        this.showFoot(false)
      } else {
        this.displayRightPanel = true
        clearTimeout(this.footTimer)
        this.isShowFoot = true
      }
    },
    /**
         * 右侧栏展开收缩
         */
    displayRightPanel: {
      handler(n) {
        this.$store.commit('GET_IS_RIGHTOPEN', n)
      },
      immediate: true,
    },
  },
  computed: {
    /**
         * 网盘内预览，当出现403，无权限异常时，控制页面上的按钮，右侧的显示
         * GYRHQA-4592 当文上传/链接者权限时，线上为“目标文件禁止此操作”，测试环境没有提示一直loading。分享的按钮也不应该显示
         */
    banAccess() {
      const errCfg = {
        noAccess: { type: 'noAccess', showRight: false, hiddenBtn: true }, // 无权限
        lowSecret: { type: 'lowSecret', showRight: false, hiddenBtn: true }, // 低密级
      }
      if (errCfg[this.abnormalType]) {
        this.displayRightPanel = errCfg[this.abnormalType] && errCfg[this.abnormalType].showRight
        return errCfg[this.abnormalType].hiddenBtn || false
      }
      return false
    },
  },
  methods: {
    /**
         * 预览失败
         * @param {*} err
         */
    loadFail(err) {
      this.abnormalType = err || 'loadFail'
    },
    /**
         * 全屏模式下鼠标静止3秒后隐藏，移动时显示
         */
    showFoot(state) {
      const me = this
      this.$nextTick(() => {
        if (!me.isFullScreen) {
          me.isShowFoot = true
          return
        }
        if (state) {
          clearTimeout(this.footTimer)
          me.isShowFoot = state
        }
        this.footTimer = setTimeout(() => {
          me.isShowFoot = false
        }, 3000)
      })
    },
    /**
         * 全屏时底部操作栏有鼠标移动时，底部分栏不隐藏
         */
    footMouseMove() {
      if (this.isFullScreen) {
        this.showFoot(true)
      }
    },
    /**
         * 校验是否为全屏
         */
    checkFull() {
      // console.log(document.fullscreenEnabled,"=========", window.fullScreen,"=========", document.webkitIsFullScreen,"=========", document.msFullscreenEnabled)
      // var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // let isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
      // if (isFull === undefined) isFull = false
      // return isFull
      return document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
    },
    /**
         * 按esc键退出全屏
         */
    pushEsc() {
      if (!this.checkFull()) {
        this.isFullScreen = false
      }
    },
    /**
         * 全屏
         */
    presentationMode(d) {
      const me = this
      this.$nextTick(() => {
        me.isFullScreen = d
      })
    },
  },
  mounted() {
    const me = this
    /**
         * 监听pdf里的发票滚动事件
         */
    window.addEventListener('message', (e) => {
      if ((e.data == 'iframeMouseMove' || e.data == 'picMouseMove') && me.isFullScreen) {
        me.showFoot(true)
      }
    }, false)
    window.addEventListener('resize', this.pushEsc)
    // document.onkeydown = (event) => { //监听f11按键
    //     if (event.keyCode === 122) {
    //     }
    // }
  },
}
